/**
 * This file is used to initialize all the widgets, namespaces, etc. for the project,
 */

import PubSub from 'pubsub-js';
window.PubSub = PubSub;

(function (win) {
    'use strict';

    var ns;

    win.Namespace = win.Namespace || {};

    ns = win.Namespace;

    ns.ooc = ns.ooc || {};
    ns.utilities = ns.utilities || {};
    ns.snippets = ns.snippets || {};

    // Defines PubSub interface. To use PubSub, you'll need to manually include the PubSub lib.
    win.PubSub = win.PubSub || {
        publish: function () {
            win.console.error('Lib PubSub is not loaded!');
        },
        subscribe: function () {
            win.console.error('Lib PubSub is not loaded!');
        }
    };

    ns.configurations = {
        isMobile: document.documentElement.classList.contains('mobile'),
        isDesktop: document.documentElement.classList.contains('desktop'),
        isTablet: document.documentElement.classList.contains('tablet'),
        isAbogados: document.body.classList.contains('abo'),
        tokens: {
            MAP_BOX: 'pk.eyJ1IjoidmVydGljYWxlcyIsImEiOiJjamtreTJpZHQxcTNiM3Ztemt4Njdqd2l6In0.1YSLbD8JEe7yVEkPvYVeyQ'
        },
        BROWSER: {
            isChrome: navigator.userAgent.indexOf('Chrome') !== -1,
            isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
            isGeoLocationEnabled: 'geolocation' in window.navigator,
            isHTML5Video: !!document.createElement('video').canPlayType
        }
    };

}(window));
